import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import App from './App.vue'
import * as config from './settings'
import { store } from './store/index'
import Checkbox from './components/Checkbox'
import KamblyForm from './components/KamblyForm'
import FormField from './components/FormField'
import Dropdown from "@/components/Dropdown";
import FormTextArea from './components/FormTextArea';
import Modal from "./components/Modal";
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
  loaderOptions: {
    autoHideBadge: true
  }
})

Vue.config.productionTip = false
Vue.prototype.$config = config
Vue.use(VueClipboard)
require('./config/vee-validate');
Vue.component('checkbox', Checkbox);
Vue.component('form-field', FormField);
Vue.component('dropdown', Dropdown);
Vue.component('form-textarea', FormTextArea);
Vue.component('kambly-form', KamblyForm);
Vue.component('modal', Modal);

new Vue({
  store,
  render: h => h(App),

}).$mount('#app')
